export default {
    active_sessions: "Активдүү сессиялар",
    ask_for_details_on_response: "Жооп берип жатканда деталдарды суроо",
    browser: "Браузер",
    browser_data: "Браузер маалыматтары",
    current_session: "Учурдагы сессия",
    delete_all_sessions_except_current: "Учурдагыдан башка бардык сессияларды жок кылуу",
    delete_attachment: "Тиркемени жок кылуу",
    delete_signed: "Кол коюлганды жок кылуу",
    failed_login_attempts: "Ийгиликсиз кирүү аракеттери",
    finished_sessions: "Аяктаган сессиялар",
    last_use: "Акыркы колдонуу",
    login_attempt: "Кирүү аракети",
    operating_system: "Операциялык система",
    password_expires_in_days: "Сырсөзүңүздүн мөөнөтү бүгүн бүтөт | Сырсөзүңүздүн мөөнөтү {day} күндөн кийин бүтөт | Сырсөзүңүздүн мөөнөтү {day} күндөн кийин бүтөт",
    password_valid_until_note: "Учурдагы сырсөздүн жарактуулук мөөнөтү:",
    question_for_women_only: "Аялдар үчүн гана суроо",
    reset_questionnaire_fill: "Анкетаны толтурууну өзгөртүү",
    sessions: "Сессиялар",
    tell_more: "Кененирээк айтып бериңиз",
    wrong_password: "Туура эмес сырсөз",
    "2fa_failed": "Эки факторлуу аутентификация катасы"
}
